export default function LogoMark({ size = 38 }) {
  return (
    <img
      src="/logo.jpeg"
      alt="The Health Plug"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        objectFit: "contain",
        background: "#8A1613",
        flexShrink: 0,
        display: "block",
      }}
    />
  );
}
